////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const logKiosk = {
	postLogKiosk: (filters = {}, queryParams = { page: '0', size: '250', sort: 'dateCreated', nameDir: 'desc' }) => ({
		type: ActionsTypes.POST_LOG_KIOSK,
		payload: {
			filters,
			queryParams,
		},
	}),
	postLogKioskSuccess: (data) => ({
		type: ActionsTypes.POST_LOG_KIOSK_SUCCESS,
		payload: { data },
	}),
	postLogKioskFailure: () => ({
		type: ActionsTypes.POST_LOG_KIOSK_FAILURE,
		payload: {},
	}),

	resetLogKiosk: () => ({
		type: ActionsTypes.RESET_LOG_KIOSK,
	}),
}

export default logKiosk
